import { render, staticRenderFns } from "./UserPermissionsPage.vue?vue&type=template&id=2d1e748a"
import script from "./UserPermissionsPage.vue?vue&type=script&lang=js"
export * from "./UserPermissionsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports